/**
 * Do not edit directly
 * Generated on Tue, 23 Jul 2024 13:51:28 GMT
 */

module.exports = {
  "letterSpacingBase": 0,
  "paragraphSpacingBase": 0,
  "textDecorationBase": "none",
  "textCaseBase": "none",
  "size3xlarge": "40px",
  "size2xlarge": "32px",
  "sizeXlarge": "24px",
  "sizeLarge": "20px",
  "sizeNormal": "16px",
  "sizeSmall": "14px",
  "sizeXsmall": "12px",
  "sizeXxsmall": "10px",
  "sizeMobile3xlarge": "32px",
  "sizeMobile2xlarge": "28px",
  "sizeMobileXlarge": "22px",
  "lineHeightXxlarge": "50px",
  "lineHeightXlarge": "44px",
  "lineHeightLarge": "34px",
  "lineHeightMedium": "26px",
  "lineHeightSmall": "22px",
  "lineHeightXsmall": "18px",
  "fontFamilySansSerif": "Mulish",
  "fontFamilySerif": "Besley",
  "weightSemiBold": 700,
  "weightBase": 500,
  "weightLight": 400,
  "weightStrong": 600,
  "weightBold": 900
};